(() => {
  const source = document.currentScript;
  const id = source?.dataset.fonioWebchatWidgetId;
  if (!id) return;
  const load = () => {
    if (document.querySelector('script[src="https://widget.fonio.ai/webchat-widget.js"]')) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://widget.fonio.ai/webchat-widget.js';
    script.dataset.fonioWebchatWidgetId = id;
    script.dataset.fonioWebchatWidgetMode = 'floating';
    document.body.append(script);
  };
  const schedule = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(load, {timeout: 1500});
    else setTimeout(load, 0);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, {once: true});
})();
